import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <main className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-xl font-semibold">That page does not exist</h1>
      <p className="mt-2 text-muted">
        <a className="text-brand-600 underline" href="/">
          Go to the home screen
        </a>
      </p>
    </main>
  ),
});
